import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-point-navi__bar" }
const _hoisted_2 = { class: "p-point-navi__label p-point-navi__label--pc" }
const _hoisted_3 = { "data-translate-skip": "" }
const _hoisted_4 = { class: "p-point-navi__label p-point-navi__label--pc" }
const _hoisted_5 = { "data-translate-skip": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGivePoint = _resolveComponent("IconGivePoint")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconExchangePoint = _resolveComponent("IconExchangePoint")!
  const _component_IconEarnPoint = _resolveComponent("IconEarnPoint")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "p-point-navi",
        style: _normalizeStyle({ '--site-color': _ctx.colorCode })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "p-point-navi__button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToArea('thanks-point-area')))
          }, [
            _createVNode(_component_IconBase, {
              class: "p-point-navi__icon",
              width: 32,
              height: 32,
              "view-box": "0 0 32 32",
              "icon-name": "ポイントを贈る"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconGivePoint, { "icon-color": "#fff" })
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.pointName), 1),
              _cache[3] || (_cache[3] = _createTextVNode("を贈る ", -1))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "p-point-navi__label p-point-navi__label--sp" }, " 贈る ", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "p-point-navi__button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToArea('product-exchange-area')))
          }, [
            _createVNode(_component_IconBase, {
              class: "p-point-navi__icon",
              width: 32,
              height: 32,
              "view-box": "0 0 32 32",
              "icon-name": "商品と交換する"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconExchangePoint, { "icon-color": "#fff" })
              ]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "p-point-navi__label p-point-navi__label--pc" }, " 商品と交換する ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "p-point-navi__label p-point-navi__label--sp" }, " 交換する ", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "p-point-navi__button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToArea('earn-point-area')))
          }, [
            _createVNode(_component_IconBase, {
              class: "p-point-navi__icon",
              width: 32,
              height: 32,
              "view-box": "0 0 32 32",
              "icon-name": "ポイントを獲得する"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconEarnPoint, { "icon-color": "#fff" })
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pointName), 1),
              _cache[7] || (_cache[7] = _createTextVNode("を獲得する ", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "p-point-navi__label p-point-navi__label--sp" }, " 獲得する ", -1))
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}